import React from 'react';

const MyHistory = () => {
    return (
        <div>
            <h2 className="text-3xl text-accent">My History</h2>
        </div>
    );
};

export default MyHistory;